import { render } from "./Skill.vue?vue&type=template&id=52d6b78a"
import script from "./Skill.vue?vue&type=script&lang=ts"
export * from "./Skill.vue?vue&type=script&lang=ts"
script.render = render

export default script